export const ENDPOINT = "api/geographyCategory/table";
export const ENDPOINT_EXCEL = "api/geographyCategory/excel";
export const ROWS_TO_DISPLAY = 5;
